module.exports = __webpack_public_path__ + "media/images/flags/kn-a4e974e81853186f152252c4d9c54dbd.svg";